module.exports = __webpack_public_path__ + "img/17a001-11.96aade93.png";